import React from "react";
import { SquareUser, Store, MapPin } from "lucide-react";

interface AvatarProps {
  entityType: "candidat" | "enseigne" | "ville" | "location";
  imageUrl?: string;
  name: string;
  size?: "xs" | "sm" | "md" | "lg" | "xl" | "xl2" | "xl3" | "xl4";
}

const SIZE_MAPPINGS = {
  xs: { avatar: "w-6 h-6", icon: 12 },
  sm: { avatar: "w-8 h-8", icon: 14 },
  md: { avatar: "w-10 h-10", icon: 16 },
  lg: { avatar: "w-12 h-12", icon: 20 },
  xl: { avatar: "w-14 h-14", icon: 24 },
  xl2: { avatar: "w-16 h-16", icon: 28 },
  xl3: { avatar: "w-20 h-20", icon: 32 },
  xl4: { avatar: "w-24 h-24", icon: 40 },
};

export function Avatar({ entityType, imageUrl, name, size = "md" }: AvatarProps) {
  const sizeClasses = SIZE_MAPPINGS[size].avatar;
  const iconSize = SIZE_MAPPINGS[size].icon;

  const getIcon = () => {
    switch (entityType) {
      case "candidat":
        return <SquareUser className="text-slate-400" size={iconSize} />;
      case "enseigne":
        return <Store className="text-slate-400" size={iconSize} />;
      case "ville":
      case "location":
        return <MapPin className="text-slate-400" size={iconSize} />;
    }
  };

  return (
    <div className={`${sizeClasses} bg-white rounded-lg border border-slate-200 p-1 overflow-hidden flex items-center justify-center flex-shrink-0`}>
      {imageUrl ? (
        <img
          src={imageUrl}
          alt={name}
          className="object-contain bg-white rounded-[6px] w-full h-full"
        />
      ) : (
        getIcon()
      )}
    </div>
  );
}
